//#region import
import React from "react";
import { Grid } from "@mui/material";
import { useLocation } from "react-router";
import { I18n } from "utilities/utilities";
import ProjectTimelineTable from "./ProjectTimelineTable";
import Tabs, { TabContent, TabItem, TabPanel } from "components/Input/Tab";
//#endregion

export default function ProjectTimelineList() {
  const location = useLocation();
  const searchParams = location.search;
  const sMode = new URLSearchParams(searchParams).get("sMode");

  return (
    <>
      <Grid container spacing={2}>
        <Grid item marginTop={"10px"} xs={12}>
          <Tabs id={"ProjectTimeline"} defaultTab={!sMode ? "Normal" : sMode}>
            <TabItem id="Normal">{`${I18n.SetText("ProjectTimeline.sNormal")}`}</TabItem>
            <TabItem id="Special">{`${I18n.SetText("ProjectTimeline.Special")}`}</TabItem>
            <TabContent id={"ProjectTimelineTabContent"}>
              <TabPanel id="Normal">
                <ProjectTimelineTable sMode="Normal" />
              </TabPanel>
              <TabPanel id="Special">
                <ProjectTimelineTable sMode="Special" />
              </TabPanel>
            </TabContent>
          </Tabs>
        </Grid>
      </Grid>
    </>
  );
}
